// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3Uy_l","header":"ClearentDisclaimer_header__FqCjr","inner":"ClearentDisclaimer_inner__1HGvK"};